export function computedEqual<T extends object>(a: T | undefined, b: T | undefined): boolean {
    if (!a && !b) return true;
    if (!a || !b) return false;
    if (a === b) return true;
    const keys = Object.keys(a) as (keyof T)[];
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((key) => a[key] === b[key]);
}
